import { render } from "./Segment.vue?vue&type=template&id=82a73500&scoped=true"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"

import "./Segment.vue?vue&type=style&index=0&id=82a73500&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-82a73500"

export default script